import { Badge, type BadgeProps } from '@/components/ui/badge';
import { InvoiceStatus } from '@/types/invoice';

interface InvoiceStatusBadgeProps {
  status: InvoiceStatus;
  className?: string;
}

const statusConfig: Record<InvoiceStatus, { label: string; variant: BadgeProps['variant']; className?: string }> = {
  draft: {
    label: 'Draft',
    variant: 'secondary',
    className: 'bg-muted text-muted-foreground',
  },
  sent: {
    label: 'Sent',
    variant: 'info',
  },
  paid: {
    label: 'Paid',
    variant: 'success',
  },
  overdue: {
    label: 'Overdue',
    variant: 'destructive-soft',
  },
  cancelled: {
    label: 'Cancelled',
    variant: 'secondary',
    className: 'bg-muted text-muted-foreground',
  },
  refunded: {
    label: 'Refunded',
    variant: 'secondary',
    className: 'bg-muted text-muted-foreground',
  },
};

export function InvoiceStatusBadge({ status, className }: InvoiceStatusBadgeProps) {
  const config = statusConfig[status] || statusConfig.draft;

  return (
    <Badge variant={config.variant} className={`${config.className || ''} ${className || ''}`.trim() || undefined}>
      {config.label}
    </Badge>
  );
}

const DISPUTE_CONFIG: Record<'open' | 'won' | 'lost', { label: string; variant: BadgeProps['variant']; className?: string }> = {
  open: { label: 'Disputed', variant: 'destructive' },
  lost: { label: 'Chargeback', variant: 'destructive-soft' },
  won: { label: 'Dispute won', variant: 'secondary', className: 'bg-muted text-muted-foreground' },
};

/** Chargeback badge shown next to the status; renders nothing when there is no dispute. */
export function InvoiceDisputeBadge({ state, className }: { state?: 'open' | 'won' | 'lost' | null; className?: string }) {
  if (!state) return null;
  const config = DISPUTE_CONFIG[state];
  return (
    <Badge variant={config.variant} className={`${config.className || ''} ${className || ''}`.trim() || undefined}>
      {config.label}
    </Badge>
  );
}
